export default __webpack_public_path__ + "static/media/img-0051.f94cdc6f.png";